"use client";

import type { VideoContainer } from "mediatools";
import { useTranslations } from "next-intl";
import { VideoFormatRadio } from "./forms";
import type { MediaOperation, OperationOptionsProps } from "./types";
import { runVideoConversion } from "./video";

interface MuteVideoOpts {
  format: VideoContainer;
}

function MuteVideoForm({ options, setOptions, disabled }: OperationOptionsProps<MuteVideoOpts>) {
  const t = useTranslations("mediaTools.options.muteVideo");
  return (
    <VideoFormatRadio
      value={options.format}
      onChange={(format) => setOptions({ format })}
      disabled={disabled}
      label={t("formatLabel")}
    />
  );
}

export const muteVideoOperation: MediaOperation<MuteVideoOpts> = {
  id: "mute-video",
  group: "video",
  inputKinds: ["video"],
  outputKind: "video",
  showSourcePreview: true,
  defaultOptions: { format: "mp4" },
  OptionsForm: MuteVideoForm,
  run: (ctx, options) =>
    runVideoConversion(ctx, { format: options.format, discardAudio: true }, "muted"),
};
